/** Both placeholder selection panels list this many candidates per page. */
export const PLACEHOLDER_SELECTION_PAGE_SIZE = 10;
export const PLACEHOLDER_SELECTION_PAGE_SIZE_OPTIONS = [
  PLACEHOLDER_SELECTION_PAGE_SIZE,
];
